// src/assets/eventsImages/galleryData.js

import event01 from "./event-01.svg";
import event03 from "./event-03.svg";
import event04 from "./event-04.svg";
import event05 from "./event-05.svg";
import event06 from "./event-06.svg";
import event07 from "./event-07.svg";
import Goa_cover from "./Goa_cover.jpeg";
import Goa2 from "./Goa2.jpeg";
import Goa3 from "./Goa3.jpeg";
import Goa4 from "./Goa4.jpeg";
import Goa5 from "./Goa5.jpeg";
import Goa6 from "./Goa6.jpeg";
import Republic_cover from "./Republic_cover.jpeg";
import Republic2 from "./Republic2.jpeg";
import Republic3 from "./Republic3.jpeg";
import Republic4 from "./Republic4.jpeg";   
import Republic5 from "./Republic5.jpeg";
import Republic6 from "./Republic6.jpeg";
import Republic7 from "./Republic7.jpeg";
import Republic8 from "./Republic8.jpeg";
import Capacity_Cover from "./Capacity_Cover.jpeg";
import Capacity2 from "./Capacity2.jpeg";
import Capacity1 from "./Capacity1.jpeg";
import Yoga_day_Cover from "./Yoga_day_Cover.jpeg";
import yoga1 from "./yoga1.jpeg";
import yoga2 from "./yoga2.jpeg";
import yoga3 from "./yoga3.jpeg";
import LSP_COVER from "./LSP_COVER.jpeg";
import LSP1 from "./LSP1.jpeg";
import LSP2 from "./LSP2.jpeg";
import LSP3 from "./LSP3.jpeg";
import LSP4 from "./LSP4.jpeg";
import LSP5 from "./LSP5.jpeg";
import LSP6 from "./LSP6.jpeg";
import Education_Loan_Scheme from "./Education_Loan_Scheme.jpeg";
import TL from "./TL.jpeg";
import Worldforestryday from "./Worldforestryday.jpeg";
// Each event can have one or many media items.
// Use type: "image" for photos and type: "video" for YouTube/embed/direct video URLs.
const galleryData = [
  {
    id: 1,
    title: "Awareness Camp-Goa",
    coverImage: Goa_cover,
    media: [
      {
        type: "image",
        src: Goa_cover,
        alt: "Sadhana - National Learning Week 2026",
      },
       {
        type: "image",
        src: Goa2,
        alt: "Sadhana - National Learning Week 2026",
      },
        {
          type: "image",
          src: Goa3,
          alt: "Sadhana - National Learning Week 2026",
        },
         {
          type: "image",
          src: Goa4,
          alt: "Sadhana - National Learning Week 2026",
        },
         {
          type: "image",
          src: Goa5,
          alt: "Sadhana - National Learning Week 2026",
        },
         {
          type: "image",
          src: Goa6,
          alt: "Sadhana - National Learning Week 2026",
        },

        

    //    {
    //   type: "video",
    //   src: "https://www.youtube.com/watch?v=VIDEO_ID",
    //   title: "Event video",
    // },
    ],
    description:
      "The Awareness Camp-Goa was organized to spread awareness about government welfare schemes, financial assistance, and livelihood opportunities, encouraging greater participation from the local community.",
  },
  {
    id: 2,
    title: "NMDFC Scheme",
    media: [
      {
        type: "video",
        src: "https://youtu.be/IOQ-BDVGicY?si=GZVjHQ3akAqdWGzM",
        alt: "NMDFC Scheme",
      },
    ],
    description:
      "The NMDFC Scheme video provides an overview of the various financial assistance programs and initiatives offered by the National Minorities Development and Finance Corporation (NMDFC) to support minority communities in India.",
  },
  {
    id: 3,
    title: "Republic day celebration 2026",
    coverImage: Republic_cover,
    media: [
      {
        type: "image",
        src: Republic2,
        alt: "Republic day celebration 2026",
      },
      {
        type: "image",
        src: Republic3,
        alt: "Republic day celebration 2026",
      },
      {
        type: "image",
        src: Republic4,
        alt: "Republic day celebration 2026",   
      },
      {
        type: "image",
        src: Republic5,
        alt: "Republic day celebration 2026",   
      },
      {
        type: "image",
        src: Republic6,
        alt: "Republic day celebration 2026",   
      },
      {
        type: "image",
        src: Republic7,
        alt: "Republic day celebration 2026",   
      },
      {
        type: "image",
        src: Republic8,
        alt: "Republic day celebration 2026",   
      },
    ],
    description:
      "NMDFC beneficiaries, invited as Special Guests of the Government of India for the Republic Day Ceremony 2026, interacted with Hon'ble Cabinet Minister Shri Kiren Rijiju in New Delhi on 25th January 2026. On 26th January 2026, the special guests gathered at Kartavya Path to experience the grandeur of the Republic Day Parade unfold in front of them.",
  },
  {
    id: 4,
    title: "Capacity Building",
    coverImage:Capacity1  ,
    media: [
      {
        type: "image",
        src: Capacity1,
        alt: "Capacity Building",
      },
      {
        type: "image",
        src: Capacity2,
        alt: "Capacity Building",
      },
      {
        type: "image",
        src: Capacity_Cover,
        alt: "Capacity Building",
      },
    ],
    description:
      "The 2-day Capacity Building Program for Channel Partners by NMDFC was inaugurated by Dr. Abha Rani Singh, CMD, in the august presence of Chief Guest Sh. Pawan Kumar, Director MoMA India on 23rd March 2026 at SCOPE Minar, New Delhi.",
  },
  {
    id: 5,
    title: "Yoga Day 2026",
    coverImage: Yoga_day_Cover,
    media: [
      {
        type: "image",
        src: Yoga_day_Cover,
        alt: "Yoga Day 2026",
      },
      {
        type: "image",
        src: yoga1,
        alt: "Yoga Day 2026",
      },
      {
        type: "image",
        src: yoga2,
        alt: "Yoga Day 2026",
      },
      {
        type: "image",
        src: yoga3,
        alt: "Yoga Day 2026",
      },
    ],
 
    description:
      "The Ministry of Minority Affairs celebrated the 12th International Day of Yoga 2026 at the CGO Complex, New Delhi. Senior officials and colleagues came together with incredible energy to embrace the transformative power of #Yoga.",
  },
  {
    id: 6,
    title: "Lok Sarvadhan Parv",
    coverImage: LSP_COVER,
    media: [
      {
        type: "image",
        src: LSP_COVER,
        alt: "Lok Sarvadhan Parv",
      },
      {
        type: "image",
        src: LSP1,
        alt: "Lok Sarvadhan Parv",
      },
      {
        type: "image",
        src: LSP2,
        alt: "Lok Sarvadhan Parv",
      },
      {
        type: "image",
        src: LSP3,
        alt: "Lok Sarvadhan Parv",
      },  
    ],
    description:
      "Lok Samvardhan Parv was held in Srinagar (5th April–13th April, 2025), Delhi (Rajghat), and Kochi. The 3rd edition was inaugurated by Shri Kiren Rijiju (Hon'ble Minister for Minority Affairs & Parliamentary Affairs, GOI) in the august presence of Shri Omar Abdullah (Hon'ble CM of J&K), with Shri George Kurian (Hon'ble MoS for Minority Affairs & Fisheries, Animal Husbandry and Dairying, GOI) as the Guest of Honour. Cultural programs unfolded, including Sufi Qawwali and energetic fusion acts, along with inauguration ceremonies, exhibition stalls, stage events, cultural performances, group photographs, exhibition displays, and participation from artisans and beneficiaries.",
  },
   {
    id: 7,
    title: "Education Loan Scheme",
    coverImage: Education_Loan_Scheme,
    media: [
      {
        type: "image",
        src: Education_Loan_Scheme,
        alt: "Education Loan Scheme",
      },

    ],
    description:
      "The Education Loan Scheme offers financial support to students from minority communities to pursue higher education in India and abroad, helping them achieve their academic and career goals.",
  }, 
     {
    id: 8,
    title: "Term Loan Scheme",
    coverImage: TL,
    media: [
      {
        type: "image",
        src: TL,
        alt: "Term Loan Scheme",
      },

    ],
    description:
      "The Term Loan Scheme provides financial assistance to eligible beneficiaries for setting up or expanding income-generating activities, promoting self-employment and entrepreneurship.",
  },
  {
    id: 9,
    title: "World Forestry Day",
    coverImage: Worldforestryday,
    media: [
      {
        type: "image",
        src: Worldforestryday,
        alt: "World Forestry Day",
      },
    ],
    description:
      "World Forestry Day, observed on 21st March, promotes the importance of forests, encourages sustainable forest management, and raises awareness about conserving natural resources and biodiversity.",
  }
];

export default galleryData;